import { gql } from '@apollo/client'

export const contentPillarDeleteMany = gql`
  mutation ContentPillarDeleteMany($ids: [String]!) {
    contentPillarDeleteMany(ids: $ids)
  }
`
